module.exports = __webpack_public_path__ + "static/img/hysteroscope-5.edff20c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-5.jpg
// module id = B7uN
// module chunks = 51